import axios from "axios";
import moment from 'moment';
import Notifications from 'react-notification-system-redux';
import { shapeData } from './common';
import { GET_RULES, NEW_TRANSACTIONS, POSTING, COMPLETED, ROOT_URL, CLEAR_RULE } from "./types";

export function clearStatus() {
  return { type: COMPLETED, payload: false };
}

export function showError(message) {
  return Notifications.warning({ message });
}

export function getRules(bookId, ruleId = null, newRuleId = null) {
    return function(dispatch) {
        axios.get(`${ROOT_URL}/books/${bookId}/rules/${ruleId || ''}`, 
        { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } })
          .then(response => {
              const payload = (newRuleId) ? [{ ...response.data[0], newRuleId }] : response.data;
              dispatch({ type: GET_RULES, payload });
      })
      .catch((error) => {
        console.log('getRules error: ', error);
        dispatch(Notifications.warning({ message: 'Could not fetch rules' }));
      });
    };
  }
  
  export function sortRules(bookId, ruleList) {
    const ruleIdList = ruleList.map(rule => rule.RuleGuid)
    return function(dispatch) {
        axios.put(`${ROOT_URL}/books/${bookId}/rulesOrder/`, ruleIdList,
        { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } })
          .then(response => {
              dispatch({ type: GET_RULES, payload: ruleList  });
      })
      .catch((error) => {
        dispatch(Notifications.warning({ message: 'Error re-ordering rules list' }));
      });
    };
  }

  export function deleteRule(bookId, ruleId, rules) {
    return function(dispatch) {
        axios.delete(`${ROOT_URL}/books/${bookId}/rules/${ruleId}`,
        { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } })
          .then(response => {
              const payload = rules.filter(rule => rule.RuleGuid !== ruleId);
              dispatch({ type: GET_RULES, payload });
      })
      .catch((error) => {
        dispatch(Notifications.warning({ message: 'Unable to delete rule' }));
      });
    };
  }

  export function deleteRules(bookId, ruleIdList, rules) {
    return function(dispatch) {
      let requestList=[];
      ruleIdList.forEach(ruleId=>{
        requestList.push(axios.delete(`${ROOT_URL}/books/${bookId}/rules/${ruleId}`,
        { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } }));
      });
      axios.all(requestList).then(response => {
            const payload = rules.filter(rule => !ruleIdList.includes(rule.RuleGuid));
            dispatch({ type: GET_RULES, payload });
      }).catch((error) => {
        dispatch(Notifications.warning({ message: 'Unable to delete rule' }));
      });
    };
  }

  export function postRule(rule, bookId, dateRange, account = undefined) {
    return function(dispatch) {
        dispatch({ type: POSTING });
        axios.post(`${ROOT_URL}/books/${bookId}/rules/`, rule,
        { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } })
        .then(() =>
          axios.get(`${ROOT_URL}/books/${bookId}/rules/`, 
        { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } }))
        .then(response => {
              dispatch({ type: GET_RULES, payload: response.data  });
              dispatch({ type: COMPLETED, payload: true });
              dispatch(Notifications.success({ message: 'Rule Saved' }));

              if (account) {
                // Get Accounts that were coded by the new rule
                axios.get(`${ROOT_URL}/books/${bookId}/transactions/${dateRange}&account=${account.value}`,
                { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype"), lastgetelapsed: 20 } })
                .then(response => {
                  const transactionLength = response.data.transactions.length;
                  const payload = response.data.transactions.map((item, index) => shapeData(item, transactionLength, index));
                  dispatch({ type: NEW_TRANSACTIONS, payload, timeStamp: moment().unix() });
                  });
              }
      })
      .catch(() => {
        dispatch({ type: COMPLETED, payload: false });
        dispatch(Notifications.warning({ message: 'Unable to save rule' }));
      });
    };
  }
  
  export function clearRule() {
    return { type: CLEAR_RULE };
  }


// WEBPACK FOOTER //
// ./src/Actions/rules.js